<template>
  <div class="relative py-16 overflow-hidden" style="position: relative; overflow: hidden; height: 40vh; padding: 80px 0;">
    <!-- Background Video -->
    <div class="absolute inset-0 w-full h-full overflow-hidden z-0" 
    style="overflow: hidden; position: absolute; top: 0; left: 0; width: 100%;">
      <video style="width: 100%;"
        class="absolute w-full h-full object-cover"
        autoplay 
        loop 
        muted 
        playsinline
      >
        <source 
          src="https://cdn.prod.website-files.com/66c75d57c5c045d15a7781e0/66e09984e21fadc7bbcf416c_tetra-data-slomo2-transcode.webm" 
          type="video/webm"
        >
        <source 
          src="https://cdn.prod.website-files.com/66c75d57c5c045d15a7781e0/66e09984e21fadc7bbcf416c_tetra-data-slomo2-transcode.mp4" 
          type="video/mp4"
        >
      </video>
      <!-- Overlay to ensure content readability -->
      <div class="absolute inset-0 bg-white/30" style="top: 0; right: 0; bottom: 0; left: 0; position: absolute; background-color: rgba(255, 255, 255, 0.3);"></div>
    </div>

    <div class="zz absolute bottom-0 left-0 w-full h-[100px] bg-blue-500 opacity-[0.5] border-b-4 border-blue-500">
      
    </div>

    <!-- Content (now with relative positioning) -->
    <div class="relative z-10" style="position: relative; z-index: 10;">
      <div class="max-w-7xl mx-auto text-center mb-16" style="max-width: 1080px; margin: 0 auto 50px auto; text-align: center;">
        <h2 class="text-5xl font-light text-[#4361ee]" style="font-size: 30px; font-weight: 300; color: rgb(0, 64, 122);">
          Парламентын судалгаа, хөгжлийн хүрээлэн <br>цахим сургалтын платформ
        </h2>
        
      </div>

      <!-- Process Steps -->
      <div class="max-w-5xl mx-auto" style="max-width: 800px; margin: 0 auto;"> 
        <form @submit.prevent="searchFire">
        <div class="profile-update-option bg-white ht-50 bd d-flex justify-content-end mg-b-20 mg-lg-b-25 rounded">
          
              <input v-model="keyword" style="width: 100%; padding-left: 20px; border-radius: 5px 0 0 5px" placeholder="Сургалтын нэрээр хайх" />
              <div class="wd-50 bd-l d-flex align-items-center justify-content-center">
                <a @click="searchFire" href="javascript:void(0)" class="link-03" data-bs-toggle="tooltip" aria-label="Search" data-bs-original-title="Search">
                  <i class="fa fa-search"></i>
                </a>
              </div>
            
            </div>
          </form>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      keyword: "",
      tasks: [],
      slide: 0,
      sliding: null
    };
  },
  mounted() {
    //this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    searchFire() {
      console.log(this.keyword);
      this.$router.push({
        name: "landingParliament",
        params: {
          id: this.$store.state.app.pages.filter(x => x.st1 == "courses")[0].id,
          cid: 0,
          keyword: this.keyword
        }
      });
    },
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.zz {
  height: 100px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  opacity: 0.5;
  border-bottom: 4px solid rgb(59, 130, 246);
  background: url('https://res.gosmart.mn/media/bg/ub.svg') repeat-x;
  background-position: bottom;
  /* filter: invert(15%) sepia(95%) saturate(6932%) hue-rotate(351deg) brightness(97%) contrast(101%); */
}
.trns{
  .ant-input{
    background: rgba(255, 255, 255, 0.8) !important;
  }
}
</style>
